<template>
  <div class="contact">
    <h1>联系我们</h1>
    <div class="office">
      <dl>
        <dt>公司总部</dt>
        <dd>地址：{{ detailList.address }}</dd>
        <dd>电话：{{ detailList.phone }}</dd>
        <dd>传真：{{ detailList.fax }}</dd>
        <dd>邮箱：{{ detailList.email }}</dd>
      </dl>
    </div>
    <div class="department">
      <dl v-if="aboutList[0]">
        <dt>{{ aboutList[0].department }}</dt>
        <dd>{{ aboutList[0].post1 }}：{{ aboutList[0].postname1 }}</dd>
        <dd>{{ aboutList[0].post2 }}：{{ aboutList[0].postname2 }}</dd>
        <dd>{{ aboutList[0].post3 }}：{{ aboutList[0].postname3 }}</dd>
        <dd>电话：{{ aboutList[1].phone }}</dd>
        <dd>传真：{{ aboutList[1].fax }}</dd>
        <dd>邮箱：{{ aboutList[1].email }}</dd>
      </dl>
    </div>
    <div class="baiDuMap" id="container"></div>
  </div>
</template>

<script>
import { postDetail, postAbout } from "@/api/company";

export default {
  name: "contact",
  data() {
    return {
      detailList: [],
      aboutList: [],
      pointResult: {
        Longitude: 0,
        Dimension: 0,
      },
      opts: {
        width: 300, // 信息窗口宽度
        height: 80, // 信息窗口高度
      },
    };
  },
  mounted() {
    const webName = this.$router.history.current.params.name;
    this.postDetail(webName);
  },
  methods: {
    // 详情
    postDetail(name) {
      postDetail({
        web_name: name,
      }).then((res) => {
        this.detailList = res.data;
        this.pointResult = {
          Longitude: res.data.Longitude,
          Dimension: res.data.Dimension,
        };
        this.baiDuMap();
        this.postAbout(res.data.organ_id);
      });
    },
    // 关于我们
    postAbout(id) {
      postAbout({
        organCode: id,
      }).then((res) => {
        this.aboutList = res.data.other_contact;
      });
    },
    // 百度地图 api
    baiDuMap() {
      let map = new BMap.Map("container");
      // 创建点坐标
      const point = new BMap.Point(
        this.pointResult.Longitude,
        this.pointResult.Dimension
      );
      // 初始化地图，设置中心点坐标和地图级别
      map.centerAndZoom(point, 15);
      
      // 向地图添加标注
      const marker = new BMap.Marker(point);
      map.addOverlay(marker);

      // 创建信息窗口对象
      const infoWindow = new BMap.InfoWindow(this.detailList.address, this.opts);
      map.openInfoWindow(infoWindow, point);

    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>